/**
 * A cache failure as one line for a log attribute. Sentry logs drop object
 * attributes, so durable-cache warnings pass strings. It reports the innermost
 * cause: a Drizzle query error's own message lists the statement's parameters,
 * which hold the cached data.
 */
export function describeError(error: unknown): string {
  let root = error;
  for (let depth = 0; depth < 8; depth++) {
    if (!(root instanceof Error) || root.cause === undefined) break;
    root = root.cause;
  }
  return root instanceof Error ? `${root.name}: ${root.message}` : String(root);
}
